export default __webpack_public_path__ + "static/media/game-card-add.d78e6c77.svg";